import React, { useEffect, useState } from "react"
import styled from "styled-components"
import ItineraryBox from "./itinerary-box"

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.gray200};
  padding-bottom: 40px;
  padding-top: 40px;

  @media (max-width: 660px) {
    flex-direction: column;
    gap: 24px;
    padding-bottom: 0px;
  }
`

const Title = styled.div`
  color: ${props => props.theme.gray900};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  @media (max-width: 500px) {
    font-size: 18px;
    line-height: 24px;
  }
`

const Column = styled.div`
  width: 69%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 660px) {
    width: 100%;
    gap: 0;
  }
`

const OptionsItinerary = ({ itinerary, setNights }) => {
  const [nightValues, setNightValues] = useState(() =>
    Array(itinerary.length).fill(1),
  )
  const [labels, setLabels] = useState(() =>
    itinerary.map((_, i) => `Day ${i + 1}`),
  )

  // Update labels and total nights whenever nightValues change
  useEffect(() => {
    let currentDay = 1
    let total = 0
    const newLabels = nightValues.map(n => {
      const nights = parseInt(n) || 1
      const start = currentDay
      const end = currentDay + nights - 1
      currentDay = end + 1
      total += nights
      return start === end ? `Day ${start}` : `Days ${start}–${end}`
    })

    setLabels(newLabels)
    setNights(total - 1)
  }, [nightValues, setNights])

  // Update night value for a specific index
  const handleNightChange = (index, newValue) => {
    setNightValues(prev => {
      const updated = [...prev]
      updated[index] = newValue
      return updated
    })
  }

  return (
    <Wrapper>
      <Title>Itinerary</Title>
      <Column>
        {itinerary.map((item, index) => (
          <ItineraryBox
            key={index}
            itinerary={item}
            index={index}
            dayLabel={labels[index]}
            onNightChange={handleNightChange}
          />
        ))}
      </Column>
    </Wrapper>
  )
}

export default OptionsItinerary
